import gql from 'graphql-tag'

export const CREATE_LEAVE_TYPE = gql`
  mutation CreateLeaveType($input: CreateLeaveTypeInput!) {
    createLeaveType(input: $input)
  }
`

export const UPDATE_LEAVE_TYPE = gql`
  mutation UpdateLeaveType($input: UpdateLeaveTypeInput!) {
    updateLeaveType(input: $input)
  }
`

export const DELETE_LEAVE_TYPE = gql`
  mutation DeleteLeaveType($company: ID!, $leaveType: ID!) {
    deleteLeaveType(company: $company, leaveType: $leaveType)
  }
`

export const CHANGE_DEFAULT_LEAVE_TYPE = gql`
  mutation ChangeDefaultLeaveType($company: ID!, $leaveType: ID!) {
    changeDefaultLeaveType(company: $company, leaveType: $leaveType)
  }
`
